import { UserStore } from '../../plugins/auth/model/UserStore';
import { AppOptions } from '../../application/options/AppOptions';
import { View } from '@Engage.Data/modules/view/View';
/**
 * PublicEvent — mirrors Connext v2 ClientsEvent.
 * Every dispatched event gets enriched with common context fields
 * that GTM/analytics bridge scripts expect at top level.
 */
export class PublicEvent {
    constructor(eventName, data) {
        this.EventName = eventName;
        this.EventData = data;
        // Spread raw data to top level (so event-specific fields like Rule are accessible)
        if (data && typeof data === 'object') {
            Object.assign(this, data);
        }
        // Enrich with common context — mirrors Connext v2 ClientsEvent constructor
        this.enrichWithContext();
    }
    enrichWithContext() {
        var _a, _b;
        try {
            const user = UserStore.getUser();
            // MG2AccountData
            this.MG2AccountData = user ? {
                Email: user.Email || '',
                UserState: user.UserState || '',
                AuthSystem: user.AuthSystem || '',
                DigitalAccess: user.DigitalAccess || null
            } : null;
            this.AuthSystem = (user === null || user === void 0 ? void 0 : user.AuthSystem) || '';
            this.Aui = '';
            // Meter info — use what's passed in EventData first, fallback to View
            if (!this.MeterLevel) {
                const activeMeter = View.activeMeterView;
                this.MeterLevel = ((_a = activeMeter === null || activeMeter === void 0 ? void 0 : activeMeter.meterLevel) === null || _a === void 0 ? void 0 : _a.toString()) || '';
                this.MeterLevelId = (activeMeter === null || activeMeter === void 0 ? void 0 : activeMeter.meterLevel) || '';
            }
            if (!this.MeterLevelMethod) {
                this.MeterLevelMethod = 'Server';
            }
            // Campaign/Conversation info
            if (!this.CampaignName) {
                this.CampaignName = '';
            }
            if (!this.Conversation) {
                this.Conversation = {
                    Id: ((_b = View.activeMeterView) === null || _b === void 0 ? void 0 : _b.activeConversationId) || null,
                    Code: View.getActiveConversationCode() || null,
                    ViewCount: View.getCurrentConversationViewCount() || 0
                };
            }
            // EventInfo
            this.EventInfo = {
                Date: new Date().toISOString(),
                TimeStamp: Date.now(),
                SessionId: AppOptions.getPageSessionId() || ''
            };
        }
        catch (_c) {
            // Don't crash event dispatch if enrichment fails
        }
    }
    isInner() {
        return false;
    }
    dispatchInnerEvent(_data, _eventName) {
        // No-op in SDK
    }
    trackEvent(_eventName, _data, _additional) {
        // No-op in SDK — analytics handled externally via GTM bridge
    }
}
